var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Preference',{attrs:{"isMSDCustom":"","customCompanyId":_vm.customCompanyId,"surveyInfo":_vm.surveyInfo,"showOverlay":_vm.showOverlay}})
}
var staticRenderFns = []

export { render, staticRenderFns }